<template>
  <div class="tool-container">
    <v-tooltip open-delay="100" top>
      <template v-slot:activator="{ on }">
        <component
          :is="icon"
          class="tool-icon"
          :class="{ selected: selected, disabled: disabled }"
          v-on="on"
          @click="$emit('buttonClick')"
        />
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "ToolButton",

  props: {
    icon: {
      required: true
    },
    tooltip: {
      type: String,
      required: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.tool-container {
  position: relative;
  padding: 5px;
}
.tool-container:hover .tooltip {
  opacity: 1;
  transition: opacity 0.5s;
  transition-delay: 1s;
}
.tooltip {
  width: 100px;
  position: absolute;
  top: -20px;
  left: calc((100px - 100%) / -2);
  margin: auto;
  text-align: center;
  opacity: 0;
  transition: opacity 0.2s;
  transition-delay: 0s;
}
.tool-icon {
  height: 12px;
  max-width: 12px;
  cursor: pointer;
}

.tool-icon.selected path {
  fill: var(--primary-highlight);
  stroke: var(--primary-highlight);
}

.tool-icon.disabled {
  cursor: default;
  pointer-events: none;
}

.tool-icon.disabled path {
  fill: #b1b6b9;
  stroke: #b1b6b9;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/MultiSelectionForm/ToolButton.vue